import gql from 'graphql-tag';

export const SAFE_RESTART_TELEGRAM_SERVER = gql`
    mutation {
        safeRestartTelegramServer
    }
`;